import { z } from "zod";
import { mediaListSchema } from "../common.js";

export const VT_TRUCK_TYPES = ["camionette", "porteur", "semi"] as const;
export type VtTruckType = (typeof VT_TRUCK_TYPES)[number];

export const VT_TRUCK_TYPE_LABELS: Record<VtTruckType, string> = {
  camionette: "Camionnette",
  porteur: "Porteur",
  semi: "Semi-remorque",
};

export const VT_GRUE_DIMENSION_MAX = ["3m", "6m", "12m"] as const;
export type VtGrueDimensionMax = (typeof VT_GRUE_DIMENSION_MAX)[number];

export const VT_GRUE_FLECHE_MAX = ["20m", "30m"] as const;
export type VtGrueFlecheMax = (typeof VT_GRUE_FLECHE_MAX)[number];

export const vtAccessSchema = z
  .object({
    truckType: z.enum(VT_TRUCK_TYPES).optional(),
    voirieRequired: z.boolean().optional(),
    difficulteDecharge: z.boolean().optional(),
    difficulteDechargeComment: z.string().optional(),
    accessPhotoStreet: mediaListSchema.optional(),
    accessPhotoProperty: mediaListSchema.optional(),
    accessPhotoInstallation: mediaListSchema.optional(),
    // Crane (visible only when terrain.needMachines === true)
    isGruable: z.boolean().optional(),
    grueDimensionMax: z.enum(VT_GRUE_DIMENSION_MAX).optional(),
    grueFlecheMax: z.enum(VT_GRUE_FLECHE_MAX).optional(),
    grueAccesDirect: z.boolean().optional(),
    grueLogistiqueDetail: z.string().optional(),
    accessPhotoGrue: mediaListSchema.optional(),
    emplacementPhotoGrue: mediaListSchema.optional(),
    accessRemarks: z.string().optional(),
  })
  .partial();

export type VtAccess = z.infer<typeof vtAccessSchema>;
